// extracted by mini-css-extract-plugin
export var cta = "style-module--cta--4fdb5";
export var ctaBasic = "style-module--cta-basic--68d0f";
export var ctaBasic__bgPattern = "style-module--cta-basic__bgPattern--269a0";
export var ctaBasic__buttons = "style-module--cta-basic__buttons--90d3e";
export var ctaBasic__text = "style-module--cta-basic__text--17d39";
export var ctaMedium = "style-module--cta--medium--131d2";
export var ctaNormal = "style-module--cta--normal--43b7d";
export var ctaSlim = "style-module--cta-slim--761ff";
export var ctaSlim__buttons = "style-module--cta-slim__buttons--483cc";
export var ctaSlim__heading = "style-module--cta-slim__heading--8bc61";
export var ctaSlim__paragraph = "style-module--cta-slim__paragraph--19446";
export var ctaSlim__text = "style-module--cta-slim__text--1935a";
export var cta__bgPattern = "style-module--cta__bgPattern--21371";
export var cta__bgPatternRight = "style-module--cta__bgPatternRight--63d49";
export var cta__block = "style-module--cta__block--846a6";
export var cta__buttons = "style-module--cta__buttons--026d0";
export var cta__content = "style-module--cta__content--c364e";
export var cta__form = "style-module--cta__form--88823";
export var cta__form__input = "style-module--cta__form__input--a040d";
export var cta__heading = "style-module--cta__heading--5544b";
export var cta__image = "style-module--cta__image--8b505";
export var cta__imageDesktop = "style-module--cta__image-desktop--0d0da";
export var cta__imageMobile = "style-module--cta__image-mobile--feea2";
export var cta__paragraph = "style-module--cta__paragraph--c79ec";
export var cta__paragraphSub = "style-module--cta__paragraphSub--66e04";
export var cta__ticks = "style-module--cta__ticks--d9aa9";
export var tick = "style-module--tick--6efe3";
export var tick__icon = "style-module--tick__icon--9b2c0";
export var tick__text = "style-module--tick__text--046d1";